import { render } from "./Users1.vue?vue&type=template&id=0cd18eb3&scoped=true"
import script from "./Users1.vue?vue&type=script&lang=js"
export * from "./Users1.vue?vue&type=script&lang=js"

import "./Users1.vue?vue&type=style&index=0&id=0cd18eb3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd18eb3"]])

export default __exports__